module.exports = __webpack_public_path__ + "media/images/figure/schedule-credit-849d6b6651882a920c87f2b0f8964dfb.gif";